import React from 'react';
import Api from "../../components/helpers/Api";
import {Button, Col, Row, Spinner} from "reactstrap";
import {RiDeleteBin6Line} from "@remixicon/react";
import {RiAddLine, RiHeartFill} from "react-icons/ri";
import {getThemePreferences} from "../../components/helpers/UserPreferenceHelpers";
import withNavigationHook from "../../hooks/withNavigationHook";

class ThemesDropdown extends React.Component {
    state = {
        isLoading: false,
        listItems: [],
        themeSelected: null,
        chosenThemeButtons: null,
    }

    componentDidMount() {
        const requestedSongBookIds = [];

        this.setState({isLoading: true});
        Api.post(`/themes?includeSongCount=true`, requestedSongBookIds)
            .then(res => {
                const listItems = res.data;
                sessionStorage.setItem("themes", JSON.stringify(listItems));
                this.setState({listItems: listItems});
                this.setState({isLoading: false});
            })
            .catch(err => {
                console.error("Error loading themes:", err);
                this.setState({ isLoading: false });
            });

        if (!sessionStorage.getItem("preferred-song-books")) {
            getThemePreferences().then(res => {
                sessionStorage.setItem("preferred-themes", JSON.stringify(res));

                this.prepareThemePills();
            });
        } else {
            this.prepareThemePills();
        }
    }

    prepareThemePills = () => {
        const preferredThemes = this.props.sessionPropName !== "preferred-themes" && sessionStorage.getItem("preferred-themes") ? JSON.parse(sessionStorage.getItem("preferred-themes")) : [];
        const preferredThemeIds = sessionStorage.getItem("preferred-themes") ? JSON.parse(sessionStorage.getItem("preferred-themes")).map(psb => psb.id) : [];
        const themes = sessionStorage.getItem(this.props.sessionPropName) == null ? [...preferredThemes] : [...JSON.parse(sessionStorage.getItem(this.props.sessionPropName)), ...preferredThemes];
        this.setState({
            chosenThemeButtons: themes
                .map((theme, index) => {
                    return this.showPill(index, theme, preferredThemeIds);
                })
        })
    }

    changeThemeHandlerFrom = (event) => {
        if (event.target.value.toUpperCase().indexOf("THEME")) { // i.e. not first option in list
            const theme = this.state.listItems.filter(b => b.id === event.target.value)[0];
            this.setState({themeSelected: theme});
        } else {
            this.setState({themeSelected: null});
        }
    };

    addButtonAvailable = () => {
        const selectedThemes = sessionStorage.getItem(this.props.sessionPropName)
            ? JSON.parse(sessionStorage.getItem(this.props.sessionPropName))
            : [];
        return this.state.themeSelected != null &&
            selectedThemes.length < 10 &&
            ((!sessionStorage.getItem("customer") && selectedThemes.length !== 1) ||
                sessionStorage.getItem("customer"));
    }

    getAllSelected = () => {
        return [...sessionStorage.getItem(this.props.sessionPropName) === null ? [] : JSON.parse(sessionStorage.getItem(this.props.sessionPropName)), ...sessionStorage.getItem("preferred-themes") === null ? [] : JSON.parse(sessionStorage.getItem("preferred-themes"))];
    }

    addThemeToList = () => {
        const allSelected = this.getAllSelected();
        const alreadyExists = allSelected.filter(sb => sb.id === this.state.themeSelected.id).length > 0;

        const currentThemes = sessionStorage.getItem(this.props.sessionPropName) == null
            ? []
            : JSON.parse(sessionStorage.getItem(this.props.sessionPropName));

        if (this.addButtonAvailable() && !alreadyExists && currentThemes.length < 10) {
            const theme = {
                id: this.state.themeSelected.id,
                title: this.state.themeSelected.title
            };

            currentThemes.push(theme);
            sessionStorage.setItem(this.props.sessionPropName, JSON.stringify(currentThemes));

            const preferredThemeIds = sessionStorage.getItem("preferred-themes")
                ? JSON.parse(sessionStorage.getItem("preferred-themes")).map(psb => psb.id)
                : [];

            this.setState({
                chosenThemeButtons: currentThemes
                    .sort((a, b) => a.displayOrder > b.displayOrder ? 1 : -1)
                    .map((theme, index) => {
                        return this.showPill(index, theme, preferredThemeIds);
                    })
            });

            this.props.enableActiveButtonHandler(true);
            sessionStorage.setItem("themeContinueEnabled", true);
        } else if (currentThemes.length >= 10) {
            alert("You can only select up to 10 themes.");
        }
    }


    removePill = (theme) => {
        let updatedThemes = sessionStorage.getItem(this.props.sessionPropName) === null ? null : JSON.parse(sessionStorage.getItem(this.props.sessionPropName)).filter(t => t.id !== theme.id);
        if (updatedThemes === null) {
            sessionStorage.removeItem(this.props.sessionPropName);
        } else {
            sessionStorage.setItem(this.props.sessionPropName, JSON.stringify(updatedThemes));
        }

        // Check preferred themes
        const foundInPreferredThemes = sessionStorage.getItem("preferred-themes") === null ? null : JSON.parse(sessionStorage.getItem("preferred-themes")).filter(sb => sb.id === theme.id);
        if (foundInPreferredThemes != null) {
            sessionStorage.setItem("preferred-themes", JSON.stringify(JSON.parse(sessionStorage.getItem("preferred-themes")).filter(sb => sb.id !== theme.id)));
        }

        this.componentDidMount();
        this.props.enableActiveButtonHandler(true);
    }

    showPill = (index, theme, preferredThemeIds) => {
        const showDeleteOption = true; //window.location.pathname.includes("your-preferences");
        return (
            <div className="passage-pill">
                <Button className='text-uppercase mx-2' color="primary" size="sm" style={{margin: '4px', width: "95%"}} onClick={this.addButtonAvailable} title={theme.title}>
                    <span style={{fontSize:"0.6rem"}}>
                        {theme.title.length <= 22 ? theme.title : theme.title.substring(0,19) + "..."}
                    </span>&nbsp;
                    {preferredThemeIds && preferredThemeIds.filter((val) => val.includes(theme.id)).length >= 1
                        ? showDeleteOption
                            ? <><a href="" title={"Remove " + theme.title + " from selected themes"} onClick={() => this.removePill(theme)} className="btn-inner--icon ml-1 mr-1" style={{verticalAlign:"top"}}><RiDeleteBin6Line size={18} style={{color:"white", float:"right"}}/><RiHeartFill size={18} style={{color:"white", float: "left"}}/></a></>
                            : <><RiHeartFill size={18} style={{color:"white", float: "right"}}/></>
                        : <><a href="" title={"Remove " + theme.title + " from selected themes"} onClick={() => this.removePill(theme)} className="btn-inner--icon ml-1 mr-1" style={{verticalAlign:"top"}}><RiDeleteBin6Line size={18} style={{color:"white", float:"right"}}/></a></>
                    }
                </Button>
            </div>);
    }

    showSongBookPill = songBook => {
        return (
            <div className="passage-pill">
                <Button className='text-uppercase mx-2 col-12' color="primary" size="sm" style={{margin: '4px', width: "95%"}}>
                    <span className="text-white" style={{fontSize:"0.6rem"}}>
                        {songBook.title.length <= 22 ? songBook.title : !songBook.shortTitle ? songBook.title.substring(0,19) + "..." : songBook.shortTitle}
                    </span>
                    {/*&nbsp;&nbsp;<a a href={this.removeBook(songBook.id)}><RiDeleteBinLine color="white" size="16"/></a>*/}
                </Button>
            </div>
        );
    }

    getThemeOptions() {
        const selectedThemeIds = sessionStorage.getItem("selected-themes") ? JSON.parse(sessionStorage.getItem("selected-themes")).map(psb => psb.id) : [];
        const preferredThemeIds = sessionStorage.getItem("preferred-themes") ? JSON.parse(sessionStorage.getItem("preferred-themes")).map(psb => psb.id) : [];

        return <>
            this.currentTestament = "";
            {
                this.state.listItems.map((listItem, index, array) => {
                    const disabled = [...selectedThemeIds,...preferredThemeIds].filter((val) => val.includes(listItem.id)).length >= 1;
                    var option = <option disabled={disabled} key={listItem.id} className="dropdown-item" value={listItem.id}>{listItem.title}</option>;
                    return <React.Fragment>
                        {option}
                    </React.Fragment>
                })
            }
        </>;
    }


    render() {
        const signedIdUser = sessionStorage.getItem("customer");

        return (
            <div>
                { !signedIdUser && <>
                    <Row>
                        <div className="col-9 my-1 text-muted" style={{opacity: 0.6, fontSize: "0.9rem"}}>
                            Using multiple themes is available to logged in users
                        </div>
                    </Row>
                </>}
                {signedIdUser && <>
                    <Row>
                        <div className="col-9 my-1 text-muted" style={{opacity: 0.6, fontSize: "0.9rem"}}>
                            Select up to 10 themes
                        </div>
                    </Row>
                </>}
                <Row>
                    <div className="col-12 my-1">
                    Themes
                    </div>
                </Row>
                <div className="main-content-wrapper">
                    <div className="songs-content">
                        {
                            this.state.isLoading ?
                                <div className="spinner-container">
                                    <Spinner animation="border" role="status">
                                        <span className="visually-hidden"></span>
                                    </Spinner>
                                    &nbsp;Loading themes relating to your chosen song books...
                                </div>
                                : <>
                        <Row className="">
                            <Col md="9" className="mb-2" style={{width: "100%"}}>
                                { this.state.listItems && this.state.listItems.length > 0 && <>
                                    <select id="theme" className="dropdown-toggle btn btn-secondary"
                                            style={{width: "100%"}}
                                            onChange={e => this.changeThemeHandlerFrom(e)}>
                                        <option key="no-selection-made" className="dropdown-item">Theme ...</option>
                                        {this.getThemeOptions()}
                                    </select>
                                </>}
                                { (!this.state.listItems || this.state.listItems.length === 0) && <>
                                    <span>No themes available for your selected song books</span>
                                </>}
                            </Col>
                            <Col md="3" className="">
                                    <Button
                                        className="btn-icon mb-3 mb-sm-0 col-md-12 col-xs-12"
                                        color="primary"
                                        onClick={() => this.addThemeToList()}
                                        disabled={!this.addButtonAvailable()}
                                    >
                                        <RiAddLine/>
                                        <span className="btn-inner--text">Add</span>
                                    </Button>
                            </Col>
                        </Row>
                        </>}
                    </div>
                    <div className="pills-sidebar">
                        <h2 style={{fontSize: '1rem'}}>{this.props.selectedTitle} {this.state.chosenThemeButtons?.length ? "(" + this.state.chosenThemeButtons.length + ")" : <></>}</h2>
                        {this.state.chosenThemeButtons?.length
                            ? <span></span>
                            : <p>No selection made</p>
                        }
                        {
                            this.state.chosenThemeButtons
                        }
                    </div>
                </div>
            </div>
        )
    }
};

export default withNavigationHook(ThemesDropdown);
